/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* AWS account configuration. Applicable if `cloudProvider` is set to `AWS`. 
*/
export class AwsRestoreAccountAttributesInput {
  /**
  * ARN of the role Eon assumes to access the account in AWS.
  */
  'roleArn': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "roleArn",
      "baseName": "roleArn",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsRestoreAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}

